export function scrollToHash(hash, behavior) {
    if (hash) {
        var id = document.getElementById(hash.slice(1));
        if (id) {
            var _a = id.getBoundingClientRect(), top_1 = _a.top, left = _a.left;
            window.scroll({
                top: top_1 + window.pageYOffset,
                left: left + window.pageXOffset,
                behavior: behavior,
            });
            // Focus the element, as default behavior is cancelled.
            // https://css-tricks.com/snippets/jquery/smooth-scrolling/
            id.focus();
        }
    }
    else {
        window.scroll({
            top: 0,
            left: 0,
            behavior: behavior,
        });
    }
}
//# sourceMappingURL=scrollToHash.js.map